import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { PropertiesSettings } from '../../core/configuration/properties-settings';
import { TipoPersona } from '../models/tipologiche/tipo-persona';

@Injectable()
export class FormValidationService {

  email(fieldControl: UntypedFormControl) {
    let regex = PropertiesSettings.REGEX_EMAIL;
    let value = fieldControl.value;
    if (!value || value === '' || (String(value).match(regex))) {
      return null;
    } else {
      return { format: true };
    }
  }

  codiceFiscale(fieldControl: UntypedFormControl) {
    let regex = PropertiesSettings.REGEX_CODICE_FISCALE;
    let value = fieldControl.value;
    if (!value || value === '' || (String(value).match(regex))) {
      return null;
    } else {
      return { format: true };
    }
  }

  partitaIva(fieldControl: UntypedFormControl) {
    let regex = PropertiesSettings.REGEX_PARTITA_IVA;
    let value = fieldControl.value;
    if (!value || value === '' || (String(value).match(regex))) {
      return null;
    } else {
      return { format: true };
    }
  }

  codiceFiscaleRappresentanteLegale(fieldControl: UntypedFormControl) {
      let regex = PropertiesSettings.REGEX_CODICE_FISCALE_RAPPRESENTANTE_LEGALE;
      let value = fieldControl.value;
      if (!value || value === '' || (String(value).match(regex))) {
        return null;
      } else {
        return { format: true };
      }
    }

  numeri(fieldControl: UntypedFormControl) {
    let regex = PropertiesSettings.REGEX_NUMERI;
    let value = fieldControl.value;
    if (!value || value === '' || (String(value).match(regex))) {
      return null;
    } else {
      return { format: true };
    }
  }

  decimali(fieldControl: UntypedFormControl){
    let regex = PropertiesSettings.REGEX_DECIMALI;
    let value = fieldControl.value;
    if (!value || value === '' || (String(value).match(regex))) {
      return null;
    } else {
      return { format: true };
    }
  }

  lettere(fieldControl: UntypedFormControl) {
    let regex = PropertiesSettings.REGEX_LETTERE;
    let value = fieldControl.value;
    if (!value || value === '' || (String(value).match(regex))) {
      return null;
    } else {
      return { format: true };
    }
  }

  telefono(fieldControl: UntypedFormControl) {
    let regex = PropertiesSettings.REGEX_TELEFONO;
    let value = fieldControl.value;
    if (!value || value === '' || (String(value).match(regex))) {
      return null;
    } else {
      return { format: true };
    }
  }

  longString(fieldControl: UntypedFormControl) {
    let regex = PropertiesSettings.REGEX_LONG_STRING;
    let value = fieldControl.value;
    if (!value || value === '' || (String(value).match(regex))) {
      return null;
    } else {
      return { format: true };
    }
  }

  anno(fieldControl: UntypedFormControl) {
    let regex = PropertiesSettings.REGEX_ANNO;
    let value = fieldControl.value;
    if (!value || value === '' || (String(value).match(regex))) {
      return null;
    } else {
      return { format: true };
    }
  }

  cap(fieldControl: UntypedFormControl) {
      let regex = PropertiesSettings.REGEX_CAP;
      let value = fieldControl.value;
      if (!value || value === '' || (String(value).match(regex))) {
        return null;
      } else {
        return { format: true };
      }
    }

  personaFisica(nome: string, cognome: string, codiceFiscale: string, tipoPersona: TipoPersona): boolean {
    let result = false;
    if (tipoPersona && tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_FISICA && nome && nome.trim().length > 0 && cognome && cognome.trim().length > 0 && codiceFiscale && codiceFiscale.trim().length === 16 ) {
      result = true;
    }
    return result;
  }

  personaGiuridica(ragioneSociale: string, partitaIva: string, tipoPersona: TipoPersona): boolean {
    let result = false;
    if (tipoPersona && tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_GIURIDICA && ragioneSociale && ragioneSociale.trim().length > 0 && partitaIva && partitaIva.trim().length === 11) {
      result = true;
    }
    return result;
  }
}
